import { render } from "./FooterSection.vue?vue&type=template&id=7223e3ff"
import script from "./FooterSection.vue?vue&type=script&lang=js"
export * from "./FooterSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/MERCANTIL/helpdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__